package one.healthium.health_tools.ui

import one.healthium.domain.user.UserModel
import one.healthium.health_tools.ui.models.DailyStepsUiModel
import one.healthium.health_tools.ui.models.UpdateWeightUiModel
import one.healthium.health_tools.ui.models.WaterIntakeUiModel
import one.healthium.meal_plans.domain.MealPlanInfoModel
import androidx.compose.runtime.Immutable

@Immutable
internal data class HealthToolsUiState(
    val loading: Boolean = false,
    val user: UserModel? = null,
    val isMetric: Boolean = true,
    val mealPlan: MealPlanInfoModel? = null,
    val dailySteps: Long? = null,
) {
    val todayWaterIntake = user?.let {
        WaterIntakeUiModel(
            dailyAmount = user.dailyWaterIntake,
            currentValue = user.todayWaterLog?.value ?: 0f,
        )
    }

    val latestWeightLog = user?.let {
        UpdateWeightUiModel(
            currentWeight = user.currentWeight ?: 0f,
            date = user.latestWeightLog?.date,
        )
    }

    val todayStepsCounter = if (user != null && dailySteps != null) {
        DailyStepsUiModel(
            steps = dailySteps,
            goal = user.expectedDailySteps,
        )
    } else null
}
